import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    ButtonToolbar,
    Popover
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { hasPermission } from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import { Link, withRouter } from 'react-router-dom';
import { brandActions } from '../../../redux/actions/brand-actions';

// dropdown components //
import BrandsDropdown from "./BrandsDropdown";
import { adminLabels } from '../../../redux/constant/admin-label-constant';
import LookupJSON from './Lookup Definition/LookupJSON';
import BrandsDropdownLinks from './BrandsDropdownLinks';
import ConfirmAlert from '../../ThemeComponents/confirmAlert';


var Modal = require('react-bootstrap-modal');

class BrandDataDefinitions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addModal: false,
            sorted: '',
            filtered: '',
            pageSize: 10,
            brandId: this.props.match.params.brandId,
            showDropdown: this.props.match.params.brandId !== 'all' ? false : true,
            brands: [
                {
                    brandName: 'Lucky',
                    shortCode: '1AA',
                    openOrders: 'New: In progess',
                    primaryContact: 'Sherri mae 447, Sunset boulevard',
                    accountingContact: 'Sherri mae 447, Sunset boulevard',
                    created_date: 'Aug 29 2019',
                    value: 1,
                },
            ],
            // active_version: '',
            show_version: false,
            jsonData: {},
            model_id: '',
            linkClicked: false,
        };
        this.callEditState = this.callEditState.bind(this);
        this.deleteDefinition = this.deleteDefinition.bind(this);
        this.deleteDataDefinition = this.deleteDataDefinition.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
        this.handleStateSubmit = this.handleStateSubmit.bind(this);

    };
    handleStateSubmit(stateData, formType) {
        if (formType === 'add')
            this.props.storeStateCall(stateData);
        else if (formType === 'edit')
            this.props.editStateCall(stateData, this.props.editState.value);

    }

    filterSearchHandle(e) {
        this.setState({
            'filtered': e.target.value
        }, () => {
            this.refReactTable.fireFetchData()
        });
    }
    callEditState(id) {
        this.setState({
            editModalState: true
        })
        this.props.getStateCall(id);
    }

    deleteDefinition(definitionId) {
        this.props.deleteDefinitionCall(definitionId).then(res => {
            this.props.getBrandDataDefinitionsCall(this.state.brandId, this.props.current_page, '', '', this.state.pageSize);
        });
    }
    deleteDataDefinition(definitionId) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="Definition" description="Are you sure to delete the definition?" onClosePro={onClose} deleteType={() => this.deleteDefinition(definitionId)} />
                )
            }
        })
    }
    brandDataDefinitionsPagination = (page, filter, sort, pageSize) => {
        this.setState({ pageSize: pageSize }, function () {
            this.props.getBrandDataDefinitionsCall(this.state.brandId, page, filter, sort, pageSize);
        });
    }

    cloneVersion = async (id) => {
        // data/definition/{brand_data_definition}/clone
        try {
            const res = await this.props.cloneDataDefinitionCall(id);
            this.props.getBrandDataDefinitionsCall(this.state.brandId, this.props.current_page, this.state.filtered, '', this.state.pageSize);
        } catch (e) {

        }
    }

    completedWizardValidation = (id) => {
        confirmAlert({
            childrenElement: () => <div />,
            customUI: ({ onClose }) => <ConfirmAlert
                header="Completed Wizard"
                description="Do you want to clone this version?"
                onClosePro={onClose}
                onYes={() => { this.cloneVersion(id) }}
            />
        })
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.props.match.params.model !== prevProps.match.params.model) {
            window.location.reload();
        }

        if (this.props.match.params.brandId !== 'all' && this.props.match.params.brandId !== prevProps.match.params.brandId) {
            this.props.getBrandDataDefinitionsCall(this.props.match.params.brandId, 1, this.state.filtered, '', this.state.pageSize);
        }
    }

    getFullState = state => {
        this.setState(prevState => ({
            brandId: state.model_id
        }), () => {
            if (this.state.brandId)
                this.props.getBrandDataDefinitionsCall(this.state.brandId, 1, this.state.filtered, '', this.state.pageSize);
        });
    }

    makeActiveVersion = (original) => {
        this.props.markActiveVersionCall(original.id).then(res => {
            this.props.getBrandDataDefinitionsCall(this.state.brandId, 1, this.state.filtered, '', this.state.pageSize);
        })
    }

    viewJSON = (data) => {
        this.setState({
            ...this.state,
            jsonData: data,
            addModal: true,
        })
    }

    returnAttributesOriginal = (original) => {
        return {

        }
    }

    getModelId = (id) => {
        this.setState({
            model_id: id,
            linkClicked: true,
        }, () => {
            this.props.history.push(`/Admin/brand/${this.state.model_id}/data-definitions`);
        })
    }


    genCell = ({ value, original }) => {
        return (<div>
            <ButtonToolbar>
                <OverlayTrigger trigger="focus" placement="bottom" overlay={
                    <Popover id="tooltip">
                        <table className="table text-left actions_table">
                            <tbody>
                                <React.Fragment>
                                    <React.Fragment>
                                        {
                                            original.definition_status === 'completed' &&
                                            <tr>
                                                <td >
                                                    {
                                                        hasPermission('list-edit') &&
                                                        <Link to={{
                                                            pathname: '/Admin/brand-wizard', state: {
                                                                definition_status: original.definition_status,
                                                                data_definition: {
                                                                    id: original.id
                                                                },
                                                                type: 'product',
                                                                brandId: this.state.brandId,
                                                                view_mode: true,
                                                            }
                                                        }} className="">View Definition</Link>
                                                    }
                                                    {
                                                        !hasPermission('list-edit') &&
                                                        <Link to={{
                                                            pathname: '/Admin/brand-wizard', state: {
                                                                definition_status: original.definition_status,
                                                                data_definition: {
                                                                    id: original.id
                                                                },
                                                                type: 'product',
                                                                brandId: this.state.brandId,
                                                                view_mode: true,
                                                            }
                                                        }} className="">View Definition</Link>
                                                    }
                                                </td>
                                            </tr>
                                        }

                                        {
                                            original.definition_status === 'completed' &&
                                            <tr>
                                                <td>
                                                    {
                                                        hasPermission('list-edit') &&
                                                        <button onClick={() => { this.completedWizardValidation(original.id) }} className="btn_link " >
                                                            Clone this Version
                                                        </button>
                                                    }
                                                    {
                                                        !hasPermission('list-edit') &&
                                                        <button onClick={() => { this.completedWizardValidation(original.id) }} className="btn_link " >
                                                            Clone this Version
                                                        </button>
                                                    }
                                                </td>
                                            </tr>
                                        }

                                        {
                                            original.definition_status === 'pending' &&
                                            <React.Fragment>
                                                <tr>
                                                    <td >
                                                        {
                                                            hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'product',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Product Attributes</Link>
                                                        }
                                                        {
                                                            !hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'product',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Product Attributes</Link>
                                                        }
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'order',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Order Attributes</Link>
                                                        }
                                                        {
                                                            !hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'order',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Order Attributes</Link>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'export',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Export Attributes</Link>
                                                        }
                                                        {
                                                            !hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'export',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Export Attributes</Link>
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'order_steps',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Workflow Rules</Link>
                                                        }
                                                        {
                                                            !hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: '/Admin/brand-wizard', state: {
                                                                    definition_status: original.definition_status,
                                                                    data_definition: {
                                                                        id: original.id
                                                                    },
                                                                    type: 'order_steps',
                                                                    brandId: this.state.brandId,
                                                                }
                                                            }} className="">Workflow Rules</Link>
                                                        }
                                                    </td>
                                                </tr>

                                            </React.Fragment>
                                        }

                                        {
                                            original.definition_status === 'completed' &&
                                            <React.Fragment>
                                                <tr>
                                                    <td>
                                                        {
                                                            hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: `/Admin/brand/${value}/transformation-rules/edit`,
                                                                state: {
                                                                    product_attributes: original.product_attributes,
                                                                    brand_id: original.brand_id,
                                                                    definition_id: original.id
                                                                }
                                                            }} className="btn_link">Transformation Rules</Link>
                                                        }
                                                        {
                                                            !hasPermission('list-edit') &&
                                                            <Link to={{
                                                                pathname: `/Admin/brand/${value}/transformation-rules/edit`,
                                                                state: {
                                                                    product_attributes: original.product_attributes,
                                                                    brand_id: original.brand_id,
                                                                    definition_id: original.id
                                                                }
                                                            }} className="btn_link">Transformation Rules</Link>
                                                        }
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        }
                                        {
                                            original.delimiter === 'rest' &&
                                            <tr>
                                                <td>
                                                    {
                                                        hasPermission('list-edit') &&
                                                        <Link to={{
                                                            pathname: `/Admin/brand/${value}/api_view`,
                                                            state: {
                                                                brand_id: original.brand_id,
                                                                response: original
                                                            }
                                                        }} className="btn_link">REST Configuration</Link>
                                                    }
                                                    {
                                                        !hasPermission('list-edit') &&
                                                        <Link to={{
                                                            pathname: `/Admin/brand/${value}/api_view`,
                                                            state: {
                                                                brand_id: original.brand_id,
                                                                response: original
                                                            }
                                                        }} className="btn_link">REST Configuration</Link>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    </React.Fragment>
                                    {/* } */}
                                </React.Fragment>
                                {
                                    original.definition_status === 'completed' && original.active_version == false &&
                                    <React.Fragment>
                                        <tr>
                                            <td>
                                                {
                                                    hasPermission('list-edit') &&
                                                    <button onClick={() => this.makeActiveVersion(original)} className="">Restore This Version</button>
                                                }
                                                {
                                                    !hasPermission('list-edit') &&
                                                    <button onClick={() => this.makeActiveVersion(original)} className="btn_link " > Restore This Version</button>
                                                }
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                }
                                {
                                    original.active_version == false && original.version !== 1 &&
                                    <React.Fragment>
                                        <tr>
                                            <td>
                                                {
                                                    hasPermission('list-edit') &&
                                                    <button onClick={() => this.deleteDataDefinition(original.id)} className="">Delete This Version</button>
                                                }
                                                {
                                                    !hasPermission('list-edit') &&
                                                    <button onClick={() => this.deleteDataDefinition(original.id)} className="btn_link " > Delete This Version</button>
                                                }
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                }
                            </tbody>
                        </table>
                    </Popover>
                }>
                    <button type='button' className="action-button-size" ><i className="fa fa-bars" /></button>
                </OverlayTrigger>
            </ButtonToolbar>
        </div>)
    }

    render() {
        const { filtered } = this.state;
        const { pages, loading, } = this.props;
        const { brandDataDefinitionData } = this.props;
        const columns = [
            {
                Header: "Brands Listing",
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: "Brand",
                        accessor: 'brand',
                        className: "action-center",
                        Cell: ({ value, original }) => (
                            <div>
                                <span>
                                    {
                                        original.active_version == true ?
                                            <i className="fa fa-check-circle fa-md" style={{ color: 'limegreen', marginRight: '5px' }}></i>
                                            :
                                            <i className="fa fa-check-circle fa-md" style={{ color: 'limegreen', marginRight: '5px', visibility: 'hidden' }}></i>
                                    }
                                </span>
                                {value}
                            </div>
                        )
                    },
                    {
                        Header: "Version",
                        accessor: "version",
                        width: 100,
                        className: "action-center"
                    },
                    {
                        Header: "Created Date",
                        accessor: "created_at",
                        width: 200,
                        className: "action-center"
                    },
                    {
                        Header: "Sample File Name",
                        accessor: "sample_file_original_name",
                        width: 300,
                        className: "action-center"
                    },
                    {
                        Header: "File Type",
                        accessor: "sample_file_type",
                        width: 100,
                        className: "action-center"
                    },
                    {
                        Header: "Attributes (JSON)",
                        className: "action-center",
                        Cell: ({ value, original }) => (
                            <div>
                                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission('brand-management') ? 'View JSON' : adminLabels.DONT_ALLOW}</Popover>}>
                                    <span>
                                        {
                                            hasPermission('brand-management') &&
                                            <button className="viewIcon orderDetailsAction" onClick={() => { this.viewJSON(original) }}></button>
                                        }
                                        {
                                            !hasPermission('brand-management') &&
                                            <button type='button' className="viewIcon orderDetailsAction button_disabled" >&nbsp;</button>
                                        }
                                    </span>
                                </OverlayTrigger>
                            </div>
                        )
                    },
                    {
                        Header: "Definition Status",
                        accessor: "definition_status",
                        className: "action-center"
                    },
                    {
                        Header: "Actions",
                        accessor: "id",
                        Cell: ({ value, original }) => this.genCell({ value, original }),
                        className: "action-center",
                        sortable: false
                    }
                ]
            }
        ];

        return (
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            {this.state.showDropdown && (
                                                <div
                                                    className="col-md-4 pull-right"
                                                >
                                                    <BrandsDropdown
                                                        onReturnFullState={this.getFullState}
                                                        stateProp={this.state}
                                                    />
                                                </div>
                                            )}
                                            {!this.state.showDropdown &&
                                                <div
                                                    className="col-md-4 pull-right"
                                                >
                                                    <BrandsDropdownLinks
                                                        returnModelId={this.getModelId} />
                                                </div>
                                            }
                                            <Grid fluid>
                                                <Row>
                                                    <Col md={12}>
                                                        <h3 style={{ textAlign: 'center', fontWeight: "500" }}>Brand Data Definition</h3>
                                                    </Col>

                                                    <Col md={12}>
                                                        <div className="flexElem flexResponsive mt-xlg" style={{ "alignItems": "flex-start", "justifyContent": "space-between" }}>
                                                            <div className="block">

                                                            </div>

                                                            <div className="custom-search-input">
                                                                <FormInputs
                                                                    ncols={["col-md-12"]}
                                                                    onChange={this.filterSearchHandle}
                                                                    proprieties={[
                                                                        {
                                                                            type: "text",
                                                                            bsClass: "form-control",
                                                                            placeholder: "Search Brand Definitions",
                                                                            onChange: this.filterSearchHandle,
                                                                            name: "filter"
                                                                        }
                                                                    ]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col md={12} className="mt-xlg">
                                                        <ReactTable
                                                            noDataText='No brand definitions found'
                                                            data={brandDataDefinitionData}
                                                            pages={pages}
                                                            loading={loading}
                                                            columns={columns}
                                                            defaultPageSize={10}
                                                            className="-striped listing responsive"
                                                            pageData={this.brandDataDefinitionsPagination}
                                                            ref={(refReactTable) => {this.refReactTable = refReactTable;}}
                                                            manual
                                                            onFetchData={(state, instance) => {
                                                                var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                                state.pageData(state.page + 1, this.state.filtered, sort, state.pageSize);
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Grid>
                                            {
                                                <Modal className="custom_lg" show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader"
                                                >
                                                    <Modal.Header closeButton>
                                                        <Modal.Title id='ModalHeader' className="headerTitle">JSON Attributes </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <LookupJSON
                                                                    closeModel={HF.closeModal.bind(this, "addModal")}
                                                                    formTypePro="add"
                                                                    jsonData={this.state.jsonData}
                                                                    handleSubmit={this.handRulesSubmitForm}
                                                                    componentPro={'Data Definition'}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            }
                                        </div>
                                    } />
                            </Col>
                        </Row>
                    </Grid>
                </div></React.Fragment>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getBrandsListCall: (page, filter, sort, pageSize) => { dispatch(brandActions.getBrandsList(page, filter, sort, pageSize)) },
        markActiveVersionCall: (id) => { return dispatch(brandActions.markActiveVersion(id)) },
        getBrandDataDefinitionsCall: (id, page, filter, sort, pageSize) => {
            let resource_id = '';
            if (id !== undefined) {
                resource_id = id;
            }
            else {
                resource_id = 'all';
            }
            dispatch(brandActions.getBrandDataDefinitions(resource_id, page, filter, sort, pageSize))
        },
        deleteDefinitionCall: (id) => { return dispatch(brandActions.deleteBrandDataDefinition(id)) },
        cloneDataDefinitionCall: (id) => { return dispatch(brandActions.cloneDataDefinition(id)) },
    });
};

function mapStateToProps(state) {
    const { loading, pages, current_page, brandDataDefinitionData, } = state.brandReducer;
    return {
        loading, pages, current_page, brandDataDefinitionData,
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandDataDefinitions));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandDataDefinitions.jsx